import "./PageFavorites.scss"
import React from "react";
import {TopRightNav} from "../cmp/header/TopRightNav";
import {FavoritesList} from "../cmp/fav/FavoritesList";
import {useUnitsState} from "../store/UnitsState";

export function PageFavorites() {

  const state = useUnitsState()

  return <div id="app-storefront-favorites">
    <header>
      <h1>{state.company.name}</h1>
      <div data-component="TopRightNav"><TopRightNav/></div>
    </header>
    <main>
      <h1>Обране</h1>

        <FavoritesList />

    </main>
  </div>
}